var _defs, _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRedEye(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".aRedEye{fill:none;}.bRedEye{fill:#b30200;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "aRedEye",
    width: 32,
    height: 32
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "bRedEye",
    d: "M12,4C4,4,1,12,1,12s3,8,11,8,11-8,11-8S20,4,12,4Zm0,2c5.276,0,7.945,4.267,8.809,6-.865,1.717-3.554,6-8.809,6-5.276,0-7.945-4.267-8.809-6C4.057,10.287,6.745,6,12,6Zm0,2a4,4,0,1,0,4,4A4,4,0,0,0,12,8Zm0,2a2,2,0,1,1-2,2A2,2,0,0,1,12,10Z",
    transform: "translate(4 4)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedEye);
export default __webpack_public_path__ + "static/media/red_eye.28ddc07a8edd4a0fb9b8b7ecf1ac8fac.svg";
export { ForwardRef as ReactComponent };